// Port de app/camera-scan.tsx.
import { Carregando } from "@/app/Carregando";
import { Redirect, useLocalSearchParams } from "@/navigation";
import { lazy } from "react";

const CameraScreen = lazy(() => import("@/screens/Camera"));

export default function CameraScanRoute() {
  const params = useLocalSearchParams<{ tipo?: string; label?: string }>();
  // WEB: aberta por F5/deep link sem os params que o Registro monta (tipo/label/posto),
  // a câmera não tem o que registrar — as validações (cerca, posto, competência) são
  // feitas na tela anterior. Volta para a aba de ponto (docs/port/04 §5.2).
  if (!params.tipo && !params.label) return <Redirect href="/(tabs)/camera" />;
  return (
    <Carregando cor="#000000">
      <CameraScreen />
    </Carregando>
  );
}
